import { render, staticRenderFns } from "./TopMessage.vue?vue&type=template&id=53e564bc&"
import script from "./TopMessage.vue?vue&type=script&lang=js&"
export * from "./TopMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports